export default `
  mutation sendAdminEmail($recipientEmail: String!, $content: String!, $subject: String) {
    sendAdminEmail(recipientEmail: $recipientEmail, content: $content, subject: $subject) {
      email
      sent
    }
  }
`
